import { render } from "./CrisisPlanCard.vue?vue&type=template&id=14e613f8&scoped=true&ts=true&lang=pug"
import script from "./CrisisPlanCard.vue?vue&type=script&lang=ts"
export * from "./CrisisPlanCard.vue?vue&type=script&lang=ts"

import "./CrisisPlanCard.vue?vue&type=style&index=0&id=14e613f8&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./CrisisPlanCard.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/crisis/crisisPlanCard.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Fhome%2FCrisisPlanCard.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e613f8"]])

export default __exports__